import { initializeComponentRegistry } from '@owc/component-registry-connection';

const store = initializeComponentRegistry();

export const aemComponentRegistryStoreHandler = {
  getStore() { // eslint-disable-line
    return store;
  },
};
